import { render, staticRenderFns } from "./ColumnChart2.vue?vue&type=template&id=1a104afa&scoped=true"
import script from "./ColumnChart2.vue?vue&type=script&lang=js"
export * from "./ColumnChart2.vue?vue&type=script&lang=js"
import style0 from "./ColumnChart2.vue?vue&type=style&index=0&id=1a104afa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a104afa",
  null
  
)

export default component.exports